import { InputGroup, InputRightAddon } from "@chakra-ui/react";
import ReadOnlyIdWrapper from "components/Products/SkuPanel/ReadOnlyIdWrapper";
import { ControlledFormField } from "components/Products/SkuPanel/utils";
import DimensionsFieldset from "components/Shared/Forms/DimensionsFieldset";
import NumberInput from "components/Shared/Forms/NumberInput";
import UpcInput from "components/Shared/Forms/UpcInput";

type Props = {
  idEditKey?: string;
  index: number;
  isDisabled?: boolean;
  isUpcPresent: boolean;
};

export default function SkuComponent({
  idEditKey,
  index,
  isDisabled,
  isUpcPresent,
}: Props) {
  return (
    <>
      <ControlledFormField
        name={`skuComponents.${index}.upc`}
        isDisabled={isDisabled}
        renderInput={({ field: { ref, ...rest } }) => (
          <ReadOnlyIdWrapper
            key={idEditKey}
            isValuePresent={isUpcPresent}
            renderInput={({ inputRef, isReadOnly }) => (
              <UpcInput
                {...rest}
                ref={(c) => {
                  ref(c);
                  inputRef(c);
                }}
                isReadOnly={isReadOnly}
              />
            )}
          />
        )}
      />

      <ControlledFormField
        name={`skuComponents.${index}.grossWeightLbs`}
        isDisabled={isDisabled}
        renderInput={({ field }) => (
          <InputGroup>
            <NumberInput
              {...field}
              max={999}
              decimalScale={4}
              allowNegative={false}
              borderTopRightRadius={0}
              borderBottomRightRadius={0}
              minW="5.5em"
            />
            <InputRightAddon px={2}>lbs</InputRightAddon>
          </InputGroup>
        )}
      />

      <DimensionsFieldset
        ControlledFormFieldComponent={ControlledFormField}
        fieldNamePrefix={`skuComponents.${index}.dimensions`}
        isDisabled={isDisabled}
        sx={{
          "> .chakra-form-control > label": {},
        }}
      />
    </>
  );
}
